import React from 'react';
import { 
    FiBarChart, 
    FiFileText, 
    FiSettings, 
    FiMail, 
    FiTrendingUp,
    FiList,
    FiSend,
    FiHome,
    FiUserPlus,
    FiDatabase,
    FiClock,
    FiLayers,
    FiEdit,
    FiUsers
} from "react-icons/fi";

// --- Icon Map ---
const IconMap = {
    // Dashboard and Data Review
    'BarChart': FiBarChart,
    'Dashboard': FiHome,           // Home icon for main dashboard
    'ReviewResults': FiTrendingUp, // Using TrendingUp for review results

    // Admin specific icons
    'FileText': FiFileText,        // Template Management
    'Settings': FiSettings,        // System Settings
    'Send': FiSend,                // Deployed surveys / send links
    'Pending': FiClock,            // Pending deployments/approvals
    'UserPlus': FiUserPlus,        // Create Leader
    'Database': FiDatabase,        // All Data Review
    'Layers': FiLayers,            // Module Management

    // Leader
    'Mail': FiMail,                // Deploy Survey
    'ManageQs': FiEdit,            // Manage Extra Questions (edit)
    'Users': FiUsers               // Leaders / accounts
};


// --- Sidebar Item (Reusable Button) ---
const SidebarItem = ({ iconName, title, onClick, isActive }) => {
    // select the correct component based on iconName string
    const CurrentIcon = IconMap[iconName] || FiSettings; // default to FiSettings if not found

    return (
        <button
            onClick={onClick}
            className={`flex items-center w-full px-4 py-3 rounded-lg transition-colors duration-200 ${
                isActive
                    ? 'bg-indigo-600 text-white shadow-md'
                    : 'text-indigo-100 hover:bg-indigo-700 hover:text-white'
            }`}
        >
            <CurrentIcon size={20} className="mr-3 text-white" />
            <span className="font-medium">{title}</span>
        </button>
    );
};

// --- Main Sidebar Component ---
const Sidebar = ({ role, currentPage, navigate, onNavigate, className = '' }) => {
    
    // updated iconName strings to match the keys in IconMap 
    const adminItems = [
        { name: 'Dashboard', page: 'dashboard', iconName: 'Dashboard', roleName: 'Main Admin' }, // Main workflow
        { name: 'Master Template', page: 'template', iconName: 'FileText', roleName: 'Main Admin' },
        { name: 'Module Management', page: 'modules', iconName: 'Layers', roleName: 'Main Admin' },
        { name: 'Pending Deploys and Approval Requests', page: 'pending-deploy', iconName: 'Pending', roleName: 'Main Admin' },
        { name: 'Deployed Surveys', page: 'deployed-surveys', iconName: 'Send', roleName: 'Main Admin' },
        { name: 'Leaderboard', page: 'leaderboard', iconName: 'BarChart', roleName: 'Main Admin' },
        { name: 'All Data Review', page: 'data', iconName: 'Database', roleName: 'Main Admin' },

        { name: 'Create Leader', page: 'create-leader', iconName: 'UserPlus', roleName: 'Main Admin' }, // Settings and user management
        { name: 'My Account', page: 'account', iconName: 'Users', roleName: 'Main Admin' },
        { name: 'System Settings', page: 'settings', iconName: 'Settings', roleName: 'Main Admin' },

    ];

    const leaderItems = [
        { name: 'Dashboard', page: 'dashboard', iconName: 'Dashboard', roleName: 'Module Leader' },
        { name: 'Manage Extra Questions', page: 'manage-q', iconName: 'ManageQs', roleName: 'Module Leader' },
        { name: 'Deploy Survey', page: 'deploy', iconName: 'Mail', roleName: 'Module Leader' },
        { name: 'Review My Results', page: 'review', iconName: 'ReviewResults', roleName: 'Module Leader' },
        { name: 'Settings', page: 'settings', iconName: 'Settings', roleName: 'Module Leader' }
    ];

    const items = role === 'admin' ? adminItems : leaderItems;
    const roleName = items[0]?.roleName || 'Guest';

    return (
        <nav className={`w-full lg:w-96 flex-shrink-0 bg-indigo-800 p-4 rounded-xl h-fit lg:sticky lg:top-[7.5rem] shadow-xl self-start ${className}`}>
            <h3 className="text-lg font-semibold text-white mb-4 border-b border-indigo-600 pb-2">
                {roleName} Menu
            </h3>
            <div className="space-y-2">
                {items.map((item) => (
                    <SidebarItem
                        key={item.page}
                        title={item.name}
                        iconName={item.iconName}
                        onClick={() => {
                            navigate(item.page);
                            if (onNavigate) onNavigate(item.page);
                        }}
                        isActive={currentPage === item.page}
                    />
                ))}
            </div>
        </nav>
    );
};

export default Sidebar;